import {
  Users,
  UserCheck,
  UtensilsCrossed,
  Bike,
} from "lucide-react";

import StatsCard from "../common/StatsCard/StatsCard";

import "./DashboardCards.css";

const formatNumber = (value = 0) => {
  return Number(value).toLocaleString("en-IN");
};

function DashboardCards({ dashboard = {} }) {

  const cards = [

    {
      title: "Providers",
      value: formatNumber(dashboard.totalProviders),
      icon: <UserCheck size={28} />,
      color: "#E53935",
      growth: `Pending: ${formatNumber(dashboard.pendingProviders)}`,
      subtitle: "Registered Providers",
    },

    {
      title: "Customers",
      value: formatNumber(dashboard.totalCustomers),
      icon: <Users size={28} />,
      color: "#2563EB",
      growth: "Active Users",
      subtitle: "Registered Customers",
    },

    {
      title: "Foods",
      value: formatNumber(dashboard.totalFoods),
      icon: <UtensilsCrossed size={28} />,
      color: "#16A34A",
      growth: "Available Items",
      subtitle: "Food Listings",
    },

    {
      title: "Delivery Partners",
      value: formatNumber(dashboard.totalDeliveryPartners),
      icon: <Bike size={28} />,
      color: "#F59E0B",
      growth: `Pending: ${formatNumber(dashboard.pendingDeliveryPartners)}`,
      subtitle: "Delivery Team",
    },

  ];

  return (

    <div className="dashboard-cards">

      {cards.map((card, index) => (

        <StatsCard
          key={index}
          title={card.title}
          value={card.value}
          icon={card.icon}
          color={card.color}
          growth={card.growth}
          subtitle={card.subtitle}
        />

      ))}

    </div>

  );

}

export default DashboardCards;